import { render, staticRenderFns } from "./MapObjectEditor.vue?vue&type=template&id=2b0fd000&scoped=true&"
import script from "./MapObjectEditor.vue?vue&type=script&lang=js&"
export * from "./MapObjectEditor.vue?vue&type=script&lang=js&"
import style0 from "./MapObjectEditor.vue?vue&type=style&index=0&id=2b0fd000&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0fd000",
  null
  
)

export default component.exports